// Последна защита: ако нещо се счупи при рендиране, потребителят вижда
// съобщение и бутон „Презареди“ вместо бял екран, а ние получаваме
// събитие app_crash в Google Analytics с текста на грешката.
import React from 'react';
import { Platform, Pressable, Text, View } from 'react-native';
import { reportClientError, track } from './analytics';
import { t } from './i18n';

type State = { error: Error | null };

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error): void {
    const message = String(error?.message ?? error).slice(0, 300);
    track('app_crash', { message: message.slice(0, 120) });
    reportClientError(message, 'crash');
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', padding: 24, backgroundColor: '#F6F5FB' }}>
        <Text style={{ fontSize: 18, fontWeight: '700', color: '#1A1450', textAlign: 'center' }}>{t('Нещо се обърка.')}</Text>
        <Text style={{ color: '#6E6A8C', textAlign: 'center', marginTop: 8 }}>{t('Презаредете страницата — ако проблемът остане, пишете ни на info@livupp.com.')}</Text>
        <Pressable
          onPress={() => {
            if (Platform.OS === 'web' && typeof window !== 'undefined') window.location.reload();
            else this.setState({ error: null });
          }}
          style={{ marginTop: 18, backgroundColor: '#7621A6', paddingVertical: 12, paddingHorizontal: 22, borderRadius: 12 }}
        >
          <Text style={{ color: '#fff', fontWeight: '700' }}>{t('Презареди')}</Text>
        </Pressable>
      </View>
    );
  }
}
